import { createContext } from 'react'
import type { ChartDescriptor } from '../charts'

export type ChartPopoverContextValue = {
  activeDescriptor: ChartDescriptor | null
  openChart: (descriptor: ChartDescriptor) => void
  closeChart: () => void
  registerModule: (moduleId: string, descriptor: ChartDescriptor, element: HTMLElement) => () => void
  openModule: (moduleId: string) => boolean
}

export const ChartPopoverContext = createContext<ChartPopoverContextValue | null>(null)
